import { Order } from 'store/cart/types';

export const formatCartItemsIds = (cart: Order): Array<string> => {
  return cart ? cart.items?.map(item => item.id) : [];
};
